var map = {
	"./code-css-xl.webp": "4fef",
	"./code-html-xl.webp": "16f7",
	"./code-jquery-xl.webp": "d567",
	"./code-js-xl.webp": "38e7",
	"./code-vue-xl.webp": "1830",
	"./sw-face-xl.webp": "9adf",
	"./sw-logo-xl.webp": "d398",
	"./sw-ps-xl.webp": "6066"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3338";